import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowMoreComponent } from './show-more.component';
import { DaButtonModule } from '../da-button/da-button.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ShowMoreComponent],
    imports: [CommonModule, DaButtonModule, TranslateModule],
    exports: [ShowMoreComponent]
})
export class ShowMoreModule {}
